"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Heading_1 = require("./Heading");
exports.default = Heading_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Heading/index.js
// module id = 834
// module chunks = 8